import Vue from 'vue'
import VueRouter from 'vue-router'
import ApiPage from '@/components/ApiPage'
import JournalEventDetail from '@/components/astro/JournalEventDetail'

Vue.use(VueRouter)

const Noop = { render: h => h('span') }

const TABS = [
    'sunrise-sunset',
    'moonrise-moonset',
    'solunar',
    'twilight',
    'moon-phases',
    'seasons',
    'planets',
    'world-clock',
    'journal',
    'tides',
]

const routes = [
    { path: '/', name: 'home', component: Noop },
    { path: '/api', name: 'api', component: ApiPage },
    { path: '/journal/event', name: 'journal-event', component: JournalEventDetail },
    ...TABS.map(tab => ({ path: `/${tab}`, name: tab, component: Noop })),
    { path: '/city/:citySlug', name: 'city', component: Noop },
    { path: '/city/:citySlug/:tab', name: 'city-tab', component: Noop },
    { path: '*', redirect: '/sunrise-sunset' },
]

export default new VueRouter({
    mode: 'history',
    routes,
})
